/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-04-17 07:53:42
 *
 *******************************************************/

import _ from 'lodash';
import { LIST_STORES_ACCEPT_SHOW_APP_VERSION_SWITCHING } from 'src/constants/accounts';

/**
 * Check if store could show turbo switching
 * @param {*} tenantApp
 * @returns
 */
export const checkUserEnableShowAppVersionSwitching = tenantApp => {
  const { tenantId, firstInstalledAt = '', status = '' } = tenantApp;
  const enableAppVersionSwitching = _.get(
    tenantApp,
    'settings.appSwitchingVersion.settings.enable'
  );

  //Check from settings before list because, in the future, several store could be settings false, and store still in the list

  if (typeof enableAppVersionSwitching === 'boolean') return enableAppVersionSwitching;

  if (LIST_STORES_ACCEPT_SHOW_APP_VERSION_SWITCHING.includes(tenantId)) {
    return true;
  }

  // Release for store using theme setup v3, from 2023-04-19 -> 2024-04-10 (phase 2)
  // if (firstInstalledAt >= 1681837200 && firstInstalledAt <= 1712682000 && status === 'active') {
  //   return true;
  // }

  // Release for all store except new ssr user (phase 3)
  if (firstInstalledAt <= 1712682000 && status === 'active') {
    return true;
  }

  return false;
};
